import { render, staticRenderFns } from "./comPage.vue?vue&type=template&id=9ef0a6dc&scoped=true&"
import script from "./comPage.vue?vue&type=script&lang=js&"
export * from "./comPage.vue?vue&type=script&lang=js&"
import style0 from "./comPage.vue?vue&type=style&index=0&id=9ef0a6dc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ef0a6dc",
  null
  
)

export default component.exports